import { Outlet } from "react-router-dom";

const OddRoot = () => {
  return <Outlet />;
};

export default OddRoot;
